import { FixedIconsMap } from './iconsMap';
import { IconsWrapped, FixedColorIconsWrapped } from './IconsWrapper';

export { IconSizes } from './utils';
export default { ...IconsWrapped, ...FixedColorIconsWrapped, ...FixedIconsMap };
